import BaseLayout from '@/components/BaseLayout.vue'
import Promotion from '@/components/CalendarPromotions/Promotion/Promotion.vue';
import api from '@/services/api';
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    data() {
        return {
            promotions: [],
        };
    },

    components: {
        Promotion,
        BaseLayout,
    },

    computed: {
        ...mapGetters({
            user: 'user/user',
        }),
    },

    methods: {
        /**
         * Get all promotions from server
         */
        getPromotions() {
            const params = new URLSearchParams();
            params.append('promoter', this.user.pcmsId);
            api.post('/api/promotions_search', params)
                .then((response) => {
                    this.promotions = response.data.body.entries;
                });
        },
    },

    watch: {
        'user.pcmsId': function (){
            this.getPromotions();
        }
    },

    mounted() {
        this.getPromotions();
    },
}